<template>
  <div :class="[widthClass, { 'relative': isPassword }]">
    <input
        :type="inputType"
        v-bind="$attrs"
        v-model="modelValue"
        :placeholder="placeholder"
        :maxlength="maxlength || undefined"
        :class="[
          'input input-bordered w-full text-sm focus:outline-none',
          error ? 'border-error focus:border-error' : 'focus:border-accent'
        ]"
    />
    <div v-if="isPassword && modelValue.length" class="absolute top-0 right-0 h-full flex items-center pr-2">
      <button
          type="button"
          class="text-gray-500 cursor-pointer focus:outline-none"
          @click="toggleReveal"
          :title="inputType === 'password' ? 'Show password' : 'Hide password'"
          :aria-label="inputType === 'password' ? 'Show password' : 'Hide password'"
      >
        <i :class="inputType === 'password' ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
      </button>
    </div>
    <p v-if="error" class="text-error text-xs mt-1">{{ error }}</p>
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";

const props = defineProps({
  placeholder: {type: String, default: "Enter text"},
  widthClass: {type: String, default: "w-full"},
  type: {type: String, default: "text"},
  error: {type: String, default: ""},
  maxlength: {type: Number, default: 0},
});

const modelValue = defineModel({type: String, default: "",});
const inputType = ref(props.type);
const isPassword = computed(() => props.type === "password");

// Watch for prop change to reset inputType
watch(() => props.type, (newType) => {
  inputType.value = newType;
});

const toggleReveal = () => {
  inputType.value = inputType.value === "password" ? "text" : "password";
};
</script>
